
import BaseFile from '../components/BaseFile.vue'
import PayloadDetail from '../components/PayloadDetail.vue'
import PayloadComposition from '../components/PayloadComposition.vue'
import { Payload } from '../services/payload'
import { defineComponent } from 'vue'
import { ZipFile } from '@/services/trim_zip'

export default defineComponent({
  components: {
    BaseFile,
    PayloadDetail,
    PayloadComposition
  },
  data() {
    return ({
      zipFile: null,
      payload: null
    } as unknown) as {
      zipFile: ZipFile
      payload: Payload
    }
  },
  methods: {
    async unpackOTA(file: File | URL) {
      this.zipFile = new ZipFile(file)
      try {
        const payload = new Payload(this.zipFile as ZipFile);
        await payload.init();
        this.payload = payload;
      } catch (err) {
        alert(`Please check if this is a correct OTA package (.zip). ${err}`)
        console.log(err)
      }
    }
  }
})
